import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Typography, Box, Alert, LinearProgress, Stack
} from '@mui/material';
import PropTypes from 'prop-types';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { importCategoriesCsv } from '../../services/categoryServices';

const ImportCsvDialog = ({ open, onClose, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile?.name.endsWith('.csv')) {
      setFile(selectedFile);
      setError('');
    } else {
      setFile(null);
      setError("Seleziona un file CSV valido.");
    }
  };

  const handleImport = async () => {
    if (!file) {
      setError("Carica un file prima di procedere.");
      return;
    }
    setLoading(true);
    setError('');
    try {
      await importCategoriesCsv(file);
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 'bold' }}>Importazione Massiva Categorie</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Carica un file CSV con le colonne: <strong>Nome, ID_Padre, PPC</strong>.
            Il sistema verificherà ogni riga prima di procedere.
          </Typography>
          
          <Box
            sx={{
              border: '2px dashed #ccc',
              borderRadius: 2,
              p: 3,
              textAlign: 'center',
              cursor: 'pointer',
              backgroundColor: '#f9f9f9',
              '&:hover': { backgroundColor: '#f0f0f0' }
            }}
            onClick={() => document.getElementById('csv-upload').click()}
          >
            <input
              type="file"
              id="csv-upload"
              accept=".csv"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
            <CloudUploadIcon sx={{ fontSize: 40, color: '#0b3d87', mb: 1 }} />
            <Typography variant="body1">
              {file ? file.name : "Clicca per caricare il file CSV"}
            </Typography>
          </Box>

          {error && <Alert severity="error">{error}</Alert>}
          {loading && (
            <Box sx={{ width: '100%' }}>
              <Typography variant="caption">Elaborazione file in corso...</Typography>
              <LinearProgress />
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={loading}>Chiudi</Button>
        <Button
          onClick={handleImport}
          variant="contained"
          disabled={!file || loading}
          sx={{ backgroundColor: '#0b3d87' }}
        >
          Inizia Importazione
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ImportCsvDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired
};

export default ImportCsvDialog;
 